<template>
  <footer>
    <div class="content">
      <div class="left-message">
        <img
          class="logo"
          src="../assets/img/footer/LogoUs.png"
          mode="widthFix"
        />
        <div class="iphone">
          <img src="../assets/img/footer/iphone.png" alt="" />
            <h3>4006880146</h3>
        </div>
        <p>工作时间：周一至周日 9:00 - 21:00</p>
          <p>加盟邮箱：181601204@qq.com</p>
      </div>
      <div class="right-message">
        <div class="all-QR-code">
          <div>
            <h6>商务合作</h6>
            <div class="QR-Code">
              <div class="code-img">
                <img
                  v-if="active == 1"
                  src="../assets/img/footer/QRCode.png"
                  mode="widthFix"
                />
                <img
                  v-else
                  src="../assets/img/footer/QRCode.png"
                  mode="widthFix"
                />
              </div>
              <div class="code-name">
                <div class="code-name-item" @click="active = 1">
                  <img
                    v-if="active == 1"
                    src="../assets/img/footer/WeChat1.png"
                    mode="widthFix"
                  />
                  <img
                    v-else
                    src="../assets/img/footer/WeChat2.png"
                    mode="widthFix"
                  />
                  <p :style="active == 1 ? '' : 'opacity: 0.5'">市场合作</p>
                </div>
                <div class="code-name-item" @click="active = 2">
                  <img
                    v-if="active == 2"
                    src="../assets/img/footer/WeChat1.png"
                    mode="widthFix"
                  />
                  <img
                    v-else
                    src="../assets/img/footer/WeChat2.png"
                    mode="widthFix"
                  />
                  <p :style="active == 2 ? '' : 'opacity: 0.5'">售后客服</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6>移动端</h6>
            <div class="QR-Code">
              <div class="code-img">
                <img
                  v-if="activeQR == 1"
                  src="../assets/img/footer/MiniProgramQR.jpg"
                  mode="widthFix"
                />
                <img
                  v-else
                  src="../assets/img/footer/APP.png"
                  mode="widthFix"
                />
              </div>
              <div class="code-name">
                <div class="code-name-item" @click="activeQR = 1">
                  <img
                    v-if="activeQR == 1"
                    src="../assets/img/footer/WeChat1.png"
                    mode="widthFix"
                  />
                  <img
                    v-else
                    src="../assets/img/footer/WeChat2.png"
                    mode="widthFix"
                  />
                  <p :style="activeQR == 1 ? '' : 'opacity: 0.5'">
                    吉时达小程序
                  </p>
                </div>
                <div class="code-name-item" @click="activeQR = 2">
                  <img
                    v-if="activeQR == 2"
                    src="../assets/img/footer/WeChat1.png"
                    mode="widthFix"
                  />
                  <img
                    v-else
                    src="../assets/img/footer/WeChat2.png"
                    mode="widthFix"
                  />
                  <p :style="activeQR == 2 ? '' : 'opacity: 0.5'">
                    吉时达APP下载
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="link-list">
          <div class="divider"></div>
          <div>
            <h6>友情链接</h6>
            <div class="a-link">
              <a href="https://api.kuaidi100.com/" target="_blank">快递100</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-name">
      Copyright &copy;{{ new Date().getFullYear() }} 吉时配快递有限公司
      <!-- Copyright &copy;2024-{{ new Date().getFullYear() }} 吉时配快递有限公司 -->
      <a
        href="https://beian.mps.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        class="link"
        >吉ICP备2024019603号-1</a
      >
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
      activeQR: 1,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1100px) {
  .content {
    padding: 0 30px;
  }
  .all-QR-code {
    margin-right: 0;
    .QR-Code {
      margin-right: 10px;
    }
  }
  .divider {
    margin: 50px 20px 0 10px;
  }
}

@media screen and (min-width: 1100px) and (max-width: 1400px) {
  .content {
    padding: 0 50px;
  }
  .all-QR-code {
    margin-right: 0;
    .QR-Code {
      margin-right: 30px;
    }
  }
  .divider {
    margin: 50px 20px 0 10px;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1700px) {
  .content {
    padding: 0 100px;
  }
  .all-QR-code {
    margin-right: 70px;
    .QR-Code {
      margin-right: 40px;
    }
  }
  .divider {
    margin: 50px 40px 0 10px;
  }
}

@media screen and (min-width: 1700px) and (max-width: 1900px) {
  .content {
    padding: 0 150px;
  }
  .all-QR-code {
    margin-right: 70px;
    .QR-Code {
      margin-right: 60px;
    }
  }
  .divider {
    margin: 50px 60px 0 10px;
  }
}


@media screen and (min-width: 1900px) {
  .content {
    padding: 0 180px;
  }
  .all-QR-code {
    margin-right: 120px;
    .QR-Code {
      margin-right: 80px;
    }
  }
  .divider {
    margin: 50px 60px 0 10px;
  }
}

footer {
  background: #171616;
  color: #fff;
  text-align: center;
  min-width: 1100px;
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .left-message {
      min-width: 25%;
      text-align: left;
      margin-top: 69px;
      .logo {
        width: 235px;
        margin-bottom: 30px;
      }
      .iphone {
        display: flex;
        align-items: center;
        margin-bottom: 38px;
        img {
          width: 35px;
          margin-right: 8px;
        }
        h3 {
          font-family: Impact;
          font-size: 34px;
          line-height: 41px;
          text-align: left;
          font-style: normal;
          margin: 0;
        }
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        text-align: left;
        font-style: normal;
      }
    }

    .right-message {
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: right;
      box-sizing: border-box;
      margin-left: 50px;
      h6 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .all-QR-code {
        display: flex;
        justify-content: right;
        .QR-Code {
          display: flex;
          align-items: center;
          .code-img {
            width: 150px;
            height: 150px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 25px;
            position: relative;
            img {
              width: 140px;
            }
          }
          .code-img::before {
            content: "";
            position: absolute;
            top: 50%;
            right: -10px; /* Adjust this value to position the triangle */
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-left: 10px solid #fff; /* Same as chat box background color */
          }
          .code-name {
            .code-name-item {
              display: flex;
              align-items: center;
              img {
                width: 21px;
                margin-right: 8px;
              }
              p {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                text-align: left;
                font-style: normal;
                color: #fff;
              }
            }
          }
        }
      }
      .link-list {
        display: flex;
        align-items: center;
        .divider {
          width: 1px;
          height: 139px;
          background-color: #ffffff;
          opacity: 0.3;
        }
        .a-link {
          min-height: 150px;
          // text-align: left;

          a {
            color: #fff;
            // text-decoration: none; /* 去掉下划线 */
          }

          a:hover {
            color: #2866ff;
          }
        }
      }
    }
  }
  .content-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    font-style: normal;
    margin-bottom: 5px;
    padding: 10px 0 19px;
    .link {
      color: #fff;
      &:nth-of-type(1) {
        margin: 0 5px;
      }
    }
  }
}
</style>
